import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import './HomeLoanInfoCard.scss';

export default function HomeLoanInfoCard({
  datatestid,
  classname,
  title,
  detail,
}) {
  return (
    <FlexContainer className="homeLoanIndoCard flex-row noWrap flex-mobile-col margT40">
      <div className="margR32 m-text-center m-margB24">
        <Image imgClass={`${classname} bgImageWH56 `} />
      </div>
      <FlexContainer className="flex-column">
        <Label
          datatestid={`${datatestid}-infoCard-title`}
          type="H5"
          typeHeader={'h4'}
          className="margB8"
        >
          {title}
        </Label>
        <Label datatestid={`${datatestid}-infoCard-detail`} type="Body-1">
          {detail}
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
}
